import Vue from 'vue'
import VueRouter from 'vue-router'
//Vue.loadScript("https://static.line-scdn.net/liff/edge/2/sdk.js")
Vue.use(VueRouter)
/*const EmptyComponent = {
  template: `<div><h1>ขออภัย ท่านไม่มีสิทธิ์เข้าใช้งาน</h1></div>`,
}*/
import Profile from "@/components/Profile01.vue";
import Register from "@/components/Register01.vue";
import Register02 from "@/components/Register02.vue";
import ShopView01 from "@/components/ShopView01.vue";
import ShopView02 from "@/components/ShopView02.vue";
import ShopView03 from "@/components/ShopView03.vue";
import ShopView04 from "@/components/ShopView04.vue";
import ShopView05 from "@/components/ShopView05.vue";
import EditProfile from "@/components/EditProfile.vue";
import LH6gift from "@/components/LH6gift.vue";
import LH6giftCode from "@/components/LH6giftCode.vue";
import LH6giftDetail from "@/components/LH6giftDetail.vue";
import LH07 from "@/components/LH07.vue";
import findbynumber from "@/components/findbynumber.vue";
import Redeem from "@/components/Redeem01.vue";
//import Redeem02 from "@/components/Redeem02.vue";
//import Redeem04 from "@/components/Redeem04.vue";
import Redeem05 from "@/components/Redeem05.vue";
//import Redeem07 from "@/components/Redeem07.vue";
import Redeem08 from "@/components/Redeem08.vue";
import RedeemHistoryDetail from "@/components/Redeem09_1.vue";
import RedeemHistory from "@/components/Redeem09.vue";
import Redeem10 from "@/components/Redeem10.vue";
import LH04_Redeempoint from "@/components/LH04_Redeempoint.vue";
import QRCODE from "@/components/QRCODE.vue";

import Product from "@/components/Product01.vue";
import Product02 from "@/components/Product02.vue";
import Cart from "@/components/Cart.vue";


import OrderHistory from "@/components/OrderHistory.vue";
import OrderHistoryDetail from "@/components/OrderHistoryDetail.vue";
import LastOrderHistoryDetail from "@/components/LastOrderHistoryDetail.vue";
import Auth from "@/components/Auth.vue";
import BirthDate from "@/components/Birthdate.vue";



//const emptyComponent = '<router-view></router-view>';



const routes = [
  /*{
    path: '*',
    component: EmptyComponent,
  },
  */
  {
    path: "/",
    name: "Auth",
    component: Auth,
  },
  {
    path: "/Register",
    name: "Register",
    component: Register,
  },
  // {
  //   path: "/Term",
  //   name: "Term",
  //   component: Register01,
  // },
  {
    path: "/Register02",
    name: "Register02",
    component: Register02,
  },
  {
    path: "/Profile",
    name: "Profile",
    meta:{ category: "Profile" },
    component: Profile,
  },
  {
    path: "/ShopView01",
    name: "ShopView01",
    meta:{ category: "Rewards" },
    component: ShopView01,
  },
  {
    path: "/ShopView02",
    name: "ShopView02",
    meta:{ category: "Rewards" },
    component: ShopView02,
  },
  {
    path: "/ShopView03",
    name: "ShopView03",
    meta:{ category: "Rewards" },
    component: ShopView03,
  },
  {
    path: "/ShopView04",
    name: "ShopView04",
    meta:{ category: "Rewards" },
    component: ShopView04,
  },
  {
    path: "/ShopView05",
    name: "ShopView05",
    meta:{ category: "Rewards" },
    component: ShopView05,
  },
  {
    path: "/EditProfile",
    name: "EditProfile",
    meta:{ category: "Profile" },
    component: EditProfile,
  },
    {
    path: "/LH6gift",
    name: "LH6gift",
    meta:{ category: "Rewards" },
    component: LH6gift,
  },
  {
    path: "/LH6giftCode",
    name: "LH6giftCode",
    meta:{ category: "Rewards" },
    component: LH6giftCode,
  },
  {
    path: "/LH6giftDetail",
    name: "LH6giftDetail",
    meta:{ category: "Rewards" },
    component: LH6giftDetail,
  },
  {
    path: "/LH07",
    name: "LH07",
    meta:{ category: "Rewards" },
    component: LH07,
  },
  {
    path: "/findbynumber",
    name: "findbynumber",
    meta:{ category: "Rewards" },
    component: findbynumber,
  },
  {
    path: "/QRCODE",
    name: "QRCODE",
    meta:{ category: "Rewards" },
    component: QRCODE,
  },
  {
    path: "/Redeem",
    name: "Redeem",
    meta:{ category: "Redeem" },
    component: Redeem,
  },
  /*{
    path: "/Redeem02",
    name: "Redeem02",
    meta:{ category: "Rewards" },
    component: Redeem02,
  },
  {
    path: "/Redeem04",
    name: "Redeem04",
    meta:{ category: "Rewards" },
    component: Redeem04,
  },*/
  {
    path: "/Redeem05/:rewardIndex",
    name: "Redeem05",
    meta:{ category: "Redeem" },
    component: Redeem05,
  },
  /*{
    path: "/Redeem07",
    name: "Redeem07",
    meta:{ category: "Rewards" },
    component: Redeem07,
  },*/
  {
    path: "/Redeem08",
    name: "Redeem08",
    meta:{ category: "Redeem" },
    component: Redeem08,
  },
  {
    path: "/RedeemHistoryDetail/:rewardIndex",
    name: "RedeemHistoryDetail",
    meta:{ category: "Redeem" },
    component: RedeemHistoryDetail,
  },
  {
    path: "/RedeemHistory",
    name: "RedeemHistory",
    meta:{ category: "Redeem" },
    component: RedeemHistory,
  },
  {
    path: "/Redeem10/:rewardIndex",
    name: "Redeem10",
    meta:{ category: "Rewards" },
    component: Redeem10,
  },
  {
    path: "/RedeemPoint",
    name: "RedeemPoint",
    meta:{ category: "Rewards" },
    component: LH04_Redeempoint,
  },
  {
    path: "/Product",
    name: "Product",
    meta:{ category: "Product" },
    component: Product,
  },
  {
    path: "/Product02/:productIndex",
    name: "Product02",
    meta:{ category: "Product" },
    component: Product02,
  },
  {
    path: "/Cart",
    name: "Cart",
    meta:{ category: "Product" },
    component: Cart,
  },
  {
    path: "/OrderHistory",
    name: "OrderHistory",
    meta:{ category: "Product" },
    component: OrderHistory,
  },
  {
    path: "/OrderHistoryDetail/:orderId",
    name: "OrderHistoryDetail",
    meta:{ category: "Product" },
    component: OrderHistoryDetail,
  },

  {
    path: "/LastOrderHistoryDetail",
    name: "LastOrderHistoryDetail",
    meta:{ category: "Product" },
    component: LastOrderHistoryDetail,
  },

  {
    path: "/page/:liffId/:redirectTo",
    name: "Auth",
    meta:{ category: "Page" },
    component: Auth,
  },
  {
    path: "/birthdate",
    name: "BirthDate",
    meta:{ category: "Page" },
    component: BirthDate,
  },
];


const router = new VueRouter({
  mode: 'history',
  routes
})

router.afterEach((to, from) => {
  console.log(from);
  Vue.nextTick( () => {
    document.title = to.meta.title ? to.meta.title : 'Loyalty Hub Application';
  });
})

export default router;
